import { DropdownMenu, DropdownMenuGroup, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuItem, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger } from 'components/ui/dropdown-menu'
import { ChevronDown, UserPlus, Loader2, X, MessagesSquare, SquarePen } from 'lucide-react'
import { Icon } from 'components/blocks/menu-icon/menu-icon'
import { useState, useEffect } from 'react'
import userParticipant from 'assets/images/userParticipant.png'
import { User } from 'lucide-react';

import { InviteUserToGroupModal } from './InviteUserToGroupModal';
import { useRemoveInvitedUser } from '../hooks/use-invite';
import { useLocation } from 'react-router-dom';
import { useParams, useSearchParams } from 'react-router-dom';
import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from 'components/ui/alert-dialog';
import { CustomDialog } from 'components/blocks/custom-dialog/custom-dialog';
import { Input } from 'components/ui/input';
import { useToast } from 'hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { useChatStore } from 'state/store/chat/use-chat-store';
import { useUpdateProject } from 'features/projects/hooks/use-create-project';
import { useGetConversationById } from 'hooks/use-conversation';
import { useConfig } from 'hooks/use-config';
import { useTheme } from 'components/core/theme-provider';
import { Button } from 'components/ui/button';
import { useCommonStore } from 'state/store/common/useCommonStore'
import { useSubscriptionStore } from 'state/store/subscription/useSubscriptionStore';
import { hasValidGroupChatComponentRoute } from 'pages/services/utilityService';
import { createConversationTitleFromUsersArray } from 'utils/chat-utilities'
import { DEFAULT_CONVERSATION_NAME } from 'utils/constants/chat-constants'
import { deleteConversationById } from 'services/storage-service';
import { useNavigate } from 'react-router-dom';
import { NewProjectModal } from 'features/projects/components/new-project-modal';
import { useQueryClient } from '@tanstack/react-query';
import { refetchProject } from 'features/projects/helpers/query-utils';
import { SidebarTrigger } from 'components/ui/sidebar'
import { UProfileMenu } from 'components/blocks/u-profile-menu'
import { useSidebar } from 'components/ui/sidebar';
import { hasValidPlanForGroupChat, hasValidPlanForStartViaShareLink } from 'pages/services/utilityService';
import { GroupShareModal } from 'features/chat/components/GroupShareModal'
import { useGroupShareModal } from 'hooks/use-group-share-modal'
import { HeaderNotificationBell } from 'pages/main/header/components/HeaderNotificationBell'
import { Tooltip, TooltipContent, TooltipProvider } from 'components/ui/tooltip'
import { TooltipTrigger } from '@radix-ui/react-tooltip'


function GroupChatHeader() {
    const { theme } = useTheme();
    const { currentPlan } = useSubscriptionStore();
    // console.log('currentPlan', currentPlan)
    const headerTitle = useChatStore((state) => state.headerTitle);
    const hasParticipants = useChatStore((state) => state.hasParticipant);
    const isNewChat = useChatStore((state) => state.isNewChat);
    const { isMobile, setOpenMobile } = useSidebar();
    const { pathname } = useLocation();
    // const [showDropdown, setShowDropdown] = useState(false);
    const { setIsIncognitoChat } = useChatStore();






    const fetchSidebarConversations = useChatStore((state) => state.fetchSidebarConversations);
    const { configurationSettings } = useConfig();
    const { mutateAsync: updateProject, isPending: isUpdatingConversation } = useUpdateProject();
    // const hasAddedAssistantAsParticipant = useChatStore((state) => state.hasAddedAssistantAsParticipant);
    const conversationId = useParams()?.conversationId;
    const projectId = useParams()?.projectId;

    const currentUser = useCommonStore((state) => state.user);

    const [inviteuserModalOpen, setInviteuserModalOpen] = useState(false);
    const setHasParticipant = useChatStore((state) => state.setHasParticipant);
    // const setHasGroupChatParticipantsArray = useChatStore((state) => state.setHasGroupChatParticipantsArray);
    const setIsLoadingParticipants = useChatStore((state) => state.setIsLoadingParticipants);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [conversationNameDropdownOpen, setConversationNameDropdownOpen] = useState(false);
    const [conversationName, setConversationName] = useState('');
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editInputValue, setEditInputValue] = useState('');
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);
    const [conversationIdToAddToProject, setConversationIdToAddToProject] = useState<string | undefined>(undefined);
    const queryClient = useQueryClient();
    const removeInvitedUserMutation = useRemoveInvitedUser();
    const navigate = useNavigate();
    const sidebarProjectsList = useChatStore((state) => state.sidebarProjectsList);
    const removeConversationFromSidebarById = useChatStore((state) => state.removeConversationFromSidebarById);
    const setNewChat = useChatStore((state) => state.setNewChat);
    const setActiveConversationId = useChatStore((state) => state.setActiveConversationId);
    const disableNewChat = useChatStore((state) => state.disableNewChat);
    const setHasParticipantsArray = useChatStore((state) => state.setHasParticipantsArray);
    const hasParticipantsArray = useChatStore((state) => state.hasParticipantsArray);
    const conversations = useChatStore((state) => state.conversations);
    // console.log('hasParticipantsArray', hasParticipantsArray)

    const [usersData, setUsersData] = useState<any>();
    const updateConversationTitleInStore = useChatStore(
        (state) => state.updateConversationTitleInStore
    );
    const { toast } = useToast();
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const isIncognitoChat = searchParams.get('incognito-chat') === 'true';

    const { data: conversation, isLoading: isLoadingConversation } = useGetConversationById(conversationId as string, isIncognitoChat);
    useEffect(() => {
        if (conversation && conversation?.conversationTitle && !isLoadingConversation) {
            // console.log('conversation in group chat header', conversation)
            setConversationName(conversation.conversationTitle);
        } else if (!isLoadingConversation && !conversation?.conversationTitle) {
            if (conversationId) {
                setConversationName(headerTitle);
            } else if (headerTitle == DEFAULT_CONVERSATION_NAME) {
                setConversationName(headerTitle);
            }
        }
    }, [conversation, isLoadingConversation, headerTitle, conversationId]);



    useEffect(() => {
        if (isNewChat) {
            setHasParticipant(false);
            setHasParticipantsArray([]);
            setUsersData("");

            // setHasGroupChatParticipantsArray([]);
        }
    }, [isNewChat, setHasParticipant, setHasParticipantsArray, setIsLoadingParticipants, setUsersData, setConversationName]);

    useEffect(() => {
        if (!conversationId) {
            setHasParticipant(false);
            setUsersData("");
            setHasParticipantsArray([]);
            return;
        }
    }, [conversationId]);




    const removeUser = async (id: string) => {
        if (!conversationId || !id) return;

        let conversationName = '';
        if (conversation && conversation?.events?.length > 0 && conversation?.events.find((event: any) => event.eventType === 'CONVERSATION_TITLE_UPDATED')) {
            conversationName = conversation.conversationTitle;
        } else {
            conversationName = createConversationTitleFromUsersArray(hasParticipantsArray.filter((user) => user.itemId != id))
        }

        try {
            const payload = {
                invitationType: 'REMOVE_USER' as const,
                userIds: [id],
                conversationId: conversationId as string,
                conversationTitle: conversationName
            };

            await removeInvitedUserMutation.mutateAsync(payload);
        } catch (error) {
            console.error('Failed to remove user from group:', error);
        }
    }

    // const handleEditClick = () => {
    //     console.log('clicked')
    //     if (conversationId) {
    //         setEditInputValue(conversationName);
    //         setEditDialogOpen(true);
    //     }
    // }
    const onIncognitoClick = () => {
        // setShowDropdown(false);
        if (isMobile) setOpenMobile(false);
        setNewChat(true);
        setIsIncognitoChat(true);
        navigate('/chat?incognito-chat=true');
    };

    const onNewChatClick = () => {
        if (disableNewChat) return;
        if (isMobile) {
            setOpenMobile(false);
        }
        setNewChat(true);
        setIsIncognitoChat(false);
        navigate('/chat');
    };



    const handleUpdateConversationName = async () => {
        if (!conversationId || !editInputValue.trim()) return;

        try {
            await updateProject({ payload: { conversationId, conversationTitle: editInputValue.trim() } });
            updateConversationTitleInStore(conversationId, editInputValue.trim());
            // await queryClient.invalidateQueries({ queryKey: ['conversation', conversationId] });
            toast({
                variant: 'success',
                title: t('SUCCESS'),
                description: t('RENAME_SUCCESS_DESCRIPTION'),
            });
            await fetchSidebarConversations(configurationSettings);
            setEditDialogOpen(false);

        }
        catch (error) {
            toast({
                variant: 'destructive',
                title: t('SOMETHING_WENT_WRONG'),
                description: t('FAILED_TO_UPDATE_CONVERSATION_NAME'),
            });
        }
        finally {
            setEditDialogOpen(false);
        }
    }

    const handleDeleteConversation = async () => {
        if (!conversationId) return;

        try {
            setIsDeleting(true);
            await deleteConversationById(conversationId, configurationSettings);
            removeConversationFromSidebarById(conversationId);
            setNewChat(true);
            setActiveConversationId(null);
            navigate('/chat');
            toast({
                variant: 'success',
                title: t('SUCCESS'),
                description: t('DELETE_SUCCESS_DESCRIPTION'),
            });
            setDeleteDialogOpen(false);
        } catch (error) {
            toast({
                variant: 'destructive',
                title: t('DELETE_FAILED'),
                description: t('DELETE_FAILED_DESCRIPTION'),
            });
            console.error('Error deleting conversation:', error);
        } finally {
            setIsDeleting(false);
            setDeleteDialogOpen(false);
        }
    }

    const fetchAndUpdateProjectAllConversations = useChatStore((state) => state.fetchAndUpdateProjectAllConversations);

    const handleAddToProject = async (projectId: string, conversationIdToUse: string) => {
        if (!conversationIdToUse || !projectId) return;

        try {
            const toProject = sidebarProjectsList.find((p) => p.id === projectId);
            if (!toProject) return;
            const payload = {
                projectId: projectId,
                conversationId: conversationIdToUse,
            };
            await updateProject({ payload: payload, skipInvalidate: true });
            await fetchAndUpdateProjectAllConversations(configurationSettings, projectId);
            removeConversationFromSidebarById(conversationIdToUse);
            toast({
                variant: 'success',
                title: t('SUCCESS'),
                description: t('MOVE_SUCCESS_DESCRIPTION'),
            });
        } catch (error) {
            toast({
                variant: 'destructive',
                title: t('MOVE_FAILED'),
                description: t('MOVE_FAILED_DESCRIPTION'),
            });
            console.error('Error adding conversation to project:', error);
        }
    }

    const isConversationDropdownDisabled = !hasParticipants && !isLoadingConversation && !conversationId;

    const handleConversationDropdownOpenChange = (open: boolean) => {
        if (!isConversationDropdownDisabled) {
            setConversationNameDropdownOpen(open);
        }
    }

    // if (isLoadingConversation) {
    //     return (
    //         <div className="flex flex-col justify-center items-center w-full">
    //             <LoaderCircle className="text-primary animate-spin" />
    //         </div>
    //     )
    // }

    const {
        showModal,
        setShowModal,
        shareToken,
        setShareToken,
        handleOpenModal
    } = useGroupShareModal(conversationId);

    const handleShareGroupChat = () => {
        handleOpenModal();
    }

    return (
        <div className={` flex justify-between items-start`}>

            <div className='flex items-center whitespace-nowrap text-sm font-medium'>
                <SidebarTrigger className="mr-1" />

                {/* User Images */}
                {usersData && usersData?.data && usersData?.data?.length > 1 && !isLoadingConversation && (
                    <div className="flex -space-x-2">
                        {usersData.data.slice(-3).map((user: any, index: number) => (
                            <div key={user.itemId || index} className="relative">
                                {user.profileImageUrl ? (
                                    <img
                                        src={user.profileImageUrl}
                                        alt={`${user.firstName} ${user.lastName}`}
                                        className="w-6 h-6 rounded-full border-2 border-white object-cover"
                                    />
                                ) : (
                                    <div className="w-6 h-6 rounded-full border-2 border-white bg-gray-200 flex items-center justify-center">
                                        {theme === 'dark' ? (
                                            <img src={userParticipant} alt="user participant" className="w-6 h-6" />
                                        ) : (
                                            <img src={userParticipant} alt="user participant" className="w-6 h-6" />
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}

                    </div>
                )}

                {
                    conversationName && hasValidGroupChatComponentRoute(pathname) ? (<>
                        <DropdownMenu open={conversationNameDropdownOpen} onOpenChange={handleConversationDropdownOpenChange}>
                            <DropdownMenuTrigger asChild>
                                <button
                                    className={`w-32 ${theme === 'dark' ? 'text-primary-200' : 'text-black-500'} sm:w-full flex items-center justify-start gap-1 ${isConversationDropdownDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                    disabled={isConversationDropdownDisabled}
                                >
                                    <span className="text-xs sm:text-sm font-medium leading-5 text-ellipsis overflow-hidden whitespace-nowrap">{conversationName}</span>
                                    <ChevronDown className="w-4 h-4" />
                                </button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent side="bottom" align="start" className="w-48 rounded-[8px]">
                                <DropdownMenuItem
                                    onClick={() => {
                                        if (conversationId) {
                                            setEditInputValue(conversationName);
                                            setEditDialogOpen(true);
                                        }
                                    }}
                                    disabled={!conversationId}
                                    className="flex items-center gap-3"
                                >
                                    <Icon
                                        name="Pencil"
                                        size={16}
                                        strokeWidth={2.2}
                                        className="text-primary"
                                    />
                                    <span className="text-sm font-light">{t('RENAME')}</span>
                                </DropdownMenuItem>
                                {conversationId && conversations[conversationId] && !conversations[conversationId]?.isGroupChat && <DropdownMenuSub>
                                    <DropdownMenuSubTrigger
                                        onClick={(e) => e.stopPropagation()}
                                        className="flex items-center gap-3"
                                        disabled={!conversationId}
                                    >
                                        <Icon
                                            name="FolderClosed"
                                            size={16}
                                            strokeWidth={2.2}
                                            className=" text-primary"
                                        />
                                        <span className="text-sm font-light">{t('ADD_TO_PROJECT')}</span>
                                    </DropdownMenuSubTrigger>
                                    <DropdownMenuSubContent>
                                        <DropdownMenuItem
                                            className="px-1"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (conversationId) {
                                                    setIsAddProjectModalOpen(true);
                                                    setConversationIdToAddToProject(conversationId);
                                                }
                                            }}
                                            disabled={!conversationId}
                                        >
                                            <Icon
                                                name="FolderPlus"
                                                size={16}
                                                strokeWidth={2.2}
                                                className=" mr-2 text-primary"
                                            />
                                            <span className="text-sm font-light">{t('NEW_PROJECT')}</span>
                                        </DropdownMenuItem>
                                        {sidebarProjectsList.filter((project) => project.id !== projectId).map((project) => (
                                            <DropdownMenuItem
                                                key={project.id}
                                                className="px-1"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (conversationId) {
                                                        handleAddToProject(project.id, conversationId);
                                                    }
                                                }}
                                                disabled={!conversationId}
                                            >
                                                <Icon
                                                    name="FolderClosed"
                                                    size={16}
                                                    strokeWidth={2.2}
                                                    className=" mr-2 text-primary"
                                                />
                                                <span className="text-sm font-light">{project.name}</span>
                                            </DropdownMenuItem>
                                        ))}
                                    </DropdownMenuSubContent>
                                </DropdownMenuSub>}
                                <DropdownMenuItem
                                    onClick={() => setDeleteDialogOpen(true)}
                                    disabled={!conversationId}
                                    className="flex items-center gap-2 text-destructive focus:text-destructive"
                                >
                                    <Icon
                                        name="Trash2"
                                        size={16}
                                        strokeWidth={2.2}
                                        className="text-destructive"
                                    />
                                    <span className="ml-1 text-sm font-light">{t('DELETE')}</span>
                                </DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </>
                    ) :
                        hasValidGroupChatComponentRoute(pathname) ? (
                            <>
                                <p className="text-sm font-light leading-[24px]">{t('NEW_CHAT_GROUP')}</p>
                                <DropdownMenu open={conversationNameDropdownOpen} onOpenChange={handleConversationDropdownOpenChange}>
                                    <DropdownMenuTrigger asChild>
                                        <button
                                            className={`p-1 flex items-center justify-center gap-1 ${isConversationDropdownDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                            disabled={isConversationDropdownDisabled}
                                        >
                                            <ChevronDown className="w-4 h-4 text-primary" />
                                        </button>
                                    </DropdownMenuTrigger>
                                    <DropdownMenuContent side="bottom" align="start" className="w-48 rounded-[8px]">
                                        <DropdownMenuItem
                                            onClick={() => {
                                                if (conversationId) {
                                                    setEditInputValue(conversationName);
                                                    setEditDialogOpen(true);
                                                }
                                            }}
                                            disabled={!conversationId}
                                            className="flex items-center gap-2"
                                        >
                                            <Icon
                                                name="Pencil"
                                                size={16}
                                                strokeWidth={2.2}
                                                className=" text-primary"
                                            />
                                            <span className="text-sm font-light">{t('RENAME')}</span>
                                        </DropdownMenuItem>
                                        {conversationId && conversations[conversationId] && !conversations[conversationId]?.isGroupChat && <DropdownMenuSub>
                                            <DropdownMenuSubTrigger
                                                onClick={(e) => e.stopPropagation()}
                                                className="flex items-center gap-3"
                                                disabled={!conversationId}
                                            >
                                                <Icon
                                                    name="FolderClosed"
                                                    size={16}
                                                    strokeWidth={2.2}
                                                    className=" text-primary"
                                                />
                                                <span className="text-sm font-light">{t('ADD_TO_PROJECT')}</span>
                                            </DropdownMenuSubTrigger>
                                            <DropdownMenuSubContent>
                                                <DropdownMenuItem
                                                    className="px-1"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (conversationId) {
                                                            setIsAddProjectModalOpen(true);
                                                            setConversationIdToAddToProject(conversationId);
                                                        }
                                                    }}
                                                    disabled={!conversationId}
                                                >
                                                    <Icon
                                                        name="FolderPlus"
                                                        size={16}
                                                        strokeWidth={2.2}
                                                        className=" mr-2 text-primary"
                                                    />
                                                    <span className="text-sm font-light">{t('NEW_PROJECT')}</span>
                                                </DropdownMenuItem>
                                                {sidebarProjectsList.filter((project) => project.id !== projectId).map((project) => (
                                                    <DropdownMenuItem
                                                        key={project.id}
                                                        className="px-1"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (conversationId) {
                                                                handleAddToProject(project.id, conversationId);
                                                            }
                                                        }}
                                                        disabled={!conversationId}
                                                    >
                                                        <Icon
                                                            name="FolderClosed"
                                                            size={16}
                                                            strokeWidth={2.2}
                                                            className=" mr-2 text-primary"
                                                        />
                                                        <span className="text-sm font-light">{project.name}</span>
                                                    </DropdownMenuItem>
                                                ))}
                                            </DropdownMenuSubContent>
                                        </DropdownMenuSub>}
                                        <DropdownMenuItem
                                            onClick={() => setDeleteDialogOpen(true)}
                                            disabled={!conversationId}
                                            className="flex items-center gap-2 text-destructive focus:text-destructive"
                                        >
                                            <Icon
                                                name="Trash2"
                                                size={16}
                                                strokeWidth={2.2}
                                                className="text-destructive"
                                            />
                                            <span className="text-sm font-light">{t('DELETE')}</span>
                                        </DropdownMenuItem>
                                    </DropdownMenuContent>
                                </DropdownMenu>
                            </>
                        ) : <></>
                }
            </div>
            <div className='flex items-start gap-2 '>



                {
                    hasValidGroupChatComponentRoute(pathname) && hasValidPlanForGroupChat(currentPlan) && !projectId && !isIncognitoChat &&
                    <>
                        {
                            hasParticipantsArray?.length > 1 ? (

                                <DropdownMenu modal={false} open={dropdownOpen} onOpenChange={setDropdownOpen}>
                                    <DropdownMenuTrigger asChild>
                                        <div className={`rounded-2xl py-[6px] sm:px-3 flex items-center gap-1.5 cursor-pointer hover:opacity-70 transition-opacity text-xs sm:text-sm font-normal leading-[18px] ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'}`}>
                                            <User className={`w-3.5 h-3.5 ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'}`} />
                                            <>
                                                {t('PARTICIPANTS')}<span className="font-medium">({hasParticipantsArray?.length})</span>
                                                <ChevronDown className={`w-4 h-4 ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'} transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
                                            </>



                                        </div>
                                    </DropdownMenuTrigger>

                                    <DropdownMenuContent className="w-56 rounded-lg p-2 shadow-lg border bg-background" align="end">
                                        <DropdownMenuGroup className=" px-2 py-3">
                                            {isLoadingConversation ? (
                                                <div className='flex items-center gap-2 py-4 justify-center'>
                                                    <Loader2 className='w-4 h-4 animate-spin text-muted-foreground' />
                                                    <p className='text-sm text-muted-foreground'>Loading participants...</p>
                                                </div>
                                            ) : hasParticipantsArray && hasParticipantsArray?.length > 0 ? (
                                                <div className="max-h-56 overflow-y-auto space-y-2 mb-5 pb-2">
                                                    {hasParticipantsArray?.map((user: any, index: number) => (
                                                        <DropdownMenuItem
                                                            key={user.itemId || index}
                                                            className='group flex items-center gap-2 w-full px-[6px] py-0 rounded-md hover:bg-accent focus:bg-accent cursor-default transition-colors'
                                                        >
                                                            <div className="flex-shrink-0">
                                                                {user.profileImageUrl ? (
                                                                    <img
                                                                        src={user.profileImageUrl}
                                                                        alt={`${user.firstName} ${user.lastName}`}
                                                                        className="w-5 h-5 rounded-full object-cover border border-border shadow-sm"
                                                                    />
                                                                ) : (

                                                                    <div className="w-5 h-5 rounded-full bg-muted flex items-center justify-center border border-border">
                                                                        {theme === 'dark' ? (
                                                                            <img src={userParticipant} alt="user participant" className="w-4 h-4" style={{ filter: 'invert(1) brightness(1.2)' }} />
                                                                        ) : (
                                                                            <img src={userParticipant} alt="user participant" className="w-4 h-4" style={{ filter: 'none' }} />
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <p className={`font-light text-sm truncate flex-1 min-w-0 ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[#555555]'}`}>
                                                                {user.firstName} {user.lastName}
                                                            </p>
                                                            <AlertDialog>
                                                                <AlertDialogTrigger asChild>
                                                                    <button
                                                                        className="opacity-0 group-hover:opacity-100 transition-all duration-200 p-1.5 rounded-md cursor-pointer "
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        aria-label={`Remove ${user.firstName} ${user.lastName}`}
                                                                    >
                                                                        <X className="w-3.5 h-3.5" />
                                                                    </button>
                                                                </AlertDialogTrigger>
                                                                <AlertDialogContent>
                                                                    <AlertDialogHeader>
                                                                        <AlertDialogTitle>Remove User from Group</AlertDialogTitle>
                                                                        <AlertDialogDescription>
                                                                            Are you sure you want to remove <strong>{user.firstName} {user.lastName}</strong> from this group chat? This action cannot be undone.
                                                                        </AlertDialogDescription>
                                                                    </AlertDialogHeader>
                                                                    <AlertDialogFooter>
                                                                        <Button variant="outline" className="rounded-[6px]">
                                                                            {t('CANCEL')}
                                                                        </Button>
                                                                        <Button
                                                                            variant="default"
                                                                            className="bg-primary rounded-[6px]"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                removeUser(user.itemId as string);
                                                                            }}
                                                                        >
                                                                            {t('REMOVE')}
                                                                            {removeInvitedUserMutation.isPending && <Loader2 className="animate-spin" />}
                                                                        </Button>

                                                                    </AlertDialogFooter>

                                                                </AlertDialogContent>
                                                            </AlertDialog>
                                                        </DropdownMenuItem>
                                                    ))}
                                                </div>
                                            ) : (

                                                <div className="max-h-64 overflow-y-auto space-y-2 pb-5">
                                                    <DropdownMenuItem
                                                        key={currentUser?.id}
                                                        className='group flex items-center gap-2 w-full px-[6px] py-0 rounded-md hover:bg-accent focus:bg-accent cursor-default transition-colors'
                                                    >
                                                        <div className="flex-shrink-0">
                                                            {currentUser?.profileImageUrl ? (
                                                                <img
                                                                    src={currentUser?.profileImageUrl}
                                                                    alt={`${currentUser?.firstName} ${currentUser?.lastName}`}
                                                                    className="w-5 h-5 rounded-full object-cover border border-border shadow-sm"
                                                                />
                                                            ) : (

                                                                <div className="w-5 h-5 rounded-full bg-muted flex items-center justify-center border border-border">
                                                                    {theme === 'dark' ? (
                                                                        <img src={userParticipant} alt="user participant" className="w-4 h-4" style={{ filter: 'invert(1) brightness(1.2)' }} />
                                                                    ) : (
                                                                        <img src={userParticipant} alt="user participant" className="w-4 h-4" style={{ filter: 'none' }} />
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <p className={`font-normal text-sm truncate flex-1 min-w-0 ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[#555555]'}`}>
                                                            {currentUser?.firstName} {currentUser?.lastName} (you)
                                                        </p>

                                                    </DropdownMenuItem>
                                                </div>
                                            )}

                                            {/* border-t border-border pt-2 mt-2 */}
                                            <div className="">

                                                <button
                                                    className='w-full h-9 border rounded-[16px] border-[#EDEDED] bg-background hover:bg-accent hover:border-accent-foreground/20 py-[6px] px-3 flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-background group'
                                                    onClick={() => {
                                                        setDropdownOpen(false);
                                                        if (hasValidPlanForStartViaShareLink(currentPlan)) {
                                                            handleShareGroupChat();
                                                        } else {
                                                            setInviteuserModalOpen(true);
                                                        }
                                                    }}
                                                // disabled={hasAddedAssistantAsParticipant}
                                                >
                                                    <UserPlus className='w-4 h-4 text-foreground group-hover:scale-110 transition-transform' />
                                                    <span className={`font-normal text-sm ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[#27272C]'}`}>
                                                        {t('ADD_PARTICIPANTS')}
                                                    </span>
                                                </button>
                                            </div>
                                        </DropdownMenuGroup>
                                    </DropdownMenuContent>
                                </DropdownMenu>
                            ) : (

                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger asChild>

                                            <button
                                                onClick={() => {
                                                    setDropdownOpen(false);
                                                    if (hasValidPlanForStartViaShareLink(currentPlan)) {
                                                        handleShareGroupChat();
                                                    } else {
                                                        setInviteuserModalOpen(true);
                                                    }
                                                }}
                                                className={`self-center w-6 h-6  md:self-start rounded-full  sm:rounded-2xl border-[0.5px] ${theme === 'dark' ? 'border-primary-200' : 'border-primary-600'} md:py-[6px] md:px-3 flex justify-center items-center gap-1.5 cursor-pointer hover:opacity-70 transition-opacity max-h-8 md:w-auto md:h-full`}
                                            >
                                                <MessagesSquare className={`w-3 h-3 ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'} hidden md:block`} />
                                                <span className={`font-normal text-sm leading-[22px] ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'} hidden md:block`}>
                                                    {t('CREATE_GROUP_CHAT') || 'Create Group Chat'}
                                                </span>
                                                <UserPlus className={`w-3 h-3 ${theme === 'dark' ? 'text-primary-200' : 'text-primary-600'} block md:hidden`} />
                                            </button>
                                        </TooltipTrigger>
                                        <TooltipContent>
                                            <p>{t('CREATE_GROUP_CHAT') || 'Create Group Chat'}</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>

                            )
                        }

                    </>
                }
                <HeaderNotificationBell />

                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>

                            {!isIncognitoChat &&

                                <div onClick={onIncognitoClick} className='cursor-pointer w-6 h-6 p-1 rounded-2xl  flex items-center self-center justify-center'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-hat-glasses-icon lucide-hat-glasses"><path d="M14 18a2 2 0 0 0-4 0" /><path d="m19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11" /><path d="M2 11h20" /><circle cx="17" cy="18" r="3" /><circle cx="7" cy="18" r="3" /></svg>
                                </div>
                            }
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{t('INCOGNITO_CHAT_ON') || 'Turn on incognito'}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>

                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>


                            {isIncognitoChat &&
                                <div onClick={onNewChatClick} className='cursor-pointer w-6 h-6 p-1 rounded-2xl flex items-center self-center justify-center'>
                                    <SquarePen />
                                </div>
                            }


                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{t('INCOGNITO_CHAT_OFF') || 'Turn off incognito'}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>



                <UProfileMenu isDropdownIconRequired={!isMobile} isFullNameRequired={!isMobile} />


            </div >

            <InviteUserToGroupModal isOpen={inviteuserModalOpen} onClose={() => setInviteuserModalOpen(false)} />

            <GroupShareModal
                showModal={showModal}
                setShowModal={setShowModal}
                shareToken={shareToken}
                setShareToken={setShareToken}
                isLoadingConversation={isLoadingConversation}
            />

            <CustomDialog
                isOpen={editDialogOpen}
                setIsOpen={setEditDialogOpen}
                isLoading={isUpdatingConversation}
                title={t('RENAME')}
                description={''}
                onConfirm={handleUpdateConversationName}
                confirmText={t('UPDATE')}
                cancelText={t('CANCEL')}
                isConfirmDisabled={!editInputValue.trim() || isUpdatingConversation}
            >
                <Input
                    value={editInputValue}
                    onChange={(e) => setEditInputValue(e.target.value)}
                    placeholder={t('CONVERSATION_NAME_PLACEHOLDER')}
                    className="w-full"
                    maxLength={50}
                />
            </CustomDialog>

            <CustomDialog
                isOpen={deleteDialogOpen}
                setIsOpen={setDeleteDialogOpen}
                isLoading={isDeleting}
                title={t('DELETE_CONVERSATION') || t('DELETE')}
                description={t('DELETE_CONVERSATION_DESCRIPTION') || t('ARE_YOU_SURE_DELETE_CONVERSATION')}
                onConfirm={handleDeleteConversation}
                confirmText={t('DELETE')}
                cancelText={t('CANCEL')}
            />

            <NewProjectModal
                callback={() => {
                    refetchProject(queryClient, '');
                    if (conversationIdToAddToProject) {
                        removeConversationFromSidebarById(conversationIdToAddToProject);
                    }
                }}
                newConversatioId={conversationIdToAddToProject}
                isOpen={isAddProjectModalOpen}
                onClose={() => setIsAddProjectModalOpen(false)}
            />
        </div >
    )
}

export default GroupChatHeader